import { render } from "./HeroiconsOutlineDotsHorizontal.vue?vue&type=template&id=11e4e087"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDotsHorizontal.vue"]])

export default __exports__